// Turkish translations
const tr = {
  // General
  appName: 'LUCIEN14',
  loading: 'Yükleniyor...',
  error: 'Bir hata oluştu',

  // Navigation
  nav: {
    home: 'Ana Sayfa',
    collections: 'Koleksiyonlar',
    culinary: 'Mutfak',
    menu: 'Menü',
    events: 'Etkinlikler',
    admin: 'Yönetici'
  },

  // Menu
  menu: {
    title: 'Menü',
    subtitle: 'CANS NUIT Seçkisi',
    date: 'KASIM 2025',
    footer: 'Menü, ilham ve mevcut malzemelere göre mevsimsel olarak değişir (MERSİN\'DE HER ŞEY YOK — DENEDİK.) Vejetaryen seçenekler talep üzerine mevcut DEĞİLDİR.',

    // Loading stages
    loading: {
      connecting: 'Sunucuya bağlanıyor...',
      fetching: 'Menü verileri alınıyor...',
      processing: 'Menü öğeleri işleniyor...',
      finalizing: 'Deneyiminiz hazırlanıyor...',
      ready: 'Neredeyse hazır...',
      error: 'Bağlantı hatası',
      notFound: 'Menü bulunamadı',
      alternative: 'Alternatif menü kaynağı deneniyor...',
      hint: 'Menümüz beklemeye değer. Sadece sizin için bir mutfak yolculuğu hazırlıyoruz...'
    },

    // Loading phrases
    loadingPhrases: [
      'En iyi alüminyum tedarik ediliyor...',
      'Sommelier\'e danışılıyor...',
      'Koruyucular tabağa yerleştiriliyor...',
      'Konserveler açılıyor...',
      'Ambiyans düzenleniyor...'
    ],

    // Section titles
    sections: {
      entrees: 'Başlangıçlar',
      plats: 'Ana Yemekler',
      cocktails: 'Kokteyl',
      whiskies: 'Viskiler',
      gins: 'Cinler',
      vins: 'Şaraplar',
      champagnes: 'Şampanyalar',
      desserts: 'Tatlılar',
      boissons: 'İçecekler'
    },

    // Error states
    errors: {
      unavailable: 'Menü Mevcut Değil',
      subtitle: 'Şef binayı terk etti',
      footer: 'Lütfen bir pizza sipariş edin.',
      title: 'Eyvah!'
    }
  },

  // Footer
  footer: {
    designed: 'LUCIEN14\'te tasarlandı',
    rights: 'Tüm hakları saklıdır.'
  },

  // Language selector
  language: {
    select: 'Dil seçin',
    en: 'İngilizce',
    fr: 'Fransızca',
    es: 'İspanyolca',
    tr: 'Türkçe'
  }
};

export default tr;
